import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ failedToLoadInventory: boolean }>;

export const DispatchSetFailedToLoadInventory: HandlerType = props => {
    props.dispatch({
        type: "Components/OrderUpload/SetFailedToLoadInventory",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetFailedToLoadInventory];

const setFailedToLoadInventory = createHandlerChainRunner(chain, "SetFailedToLoadInventory");
export default setFailedToLoadInventory;
